export default __webpack_public_path__ + "static/media/logo.121cdc50.svg";